var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5704 55.7438H3.42701C2.32545 55.7438 1.30758 55.1561 0.756819 54.2021C0.206053 53.2481 0.206061 52.0728 0.756838 51.1188L29.327 1.78545C29.8782 0.833039 30.8952 0.246582 31.9956 0.246582C33.096 0.246582 34.1131 0.833039 34.6643 1.78545L63.2344 51.1188C63.7849 52.0723 63.7852 53.247 63.2352 54.2007C62.6852 55.1545 61.6683 55.7426 60.5673 55.7438H60.5704ZM32.0003 9.49378L8.77967 49.5771H55.227L32.0003 9.49378ZM35.0682 37.2469H28.9015V21.8271H35.0682V37.2469Z",
    fill: "#FABC73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9169 40.3333H35.0836V46.4999H28.9169V40.3333Z",
    fill: "#FABC73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.2e2a859721ecbe7c505e6043d8107b11.svg";
export { ForwardRef as ReactComponent };